import { render, staticRenderFns } from "./JobFilters.vue?vue&type=template&id=2e1521ec&"
import script from "./JobFilters.vue?vue&type=script&lang=ts&"
export * from "./JobFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SelectInput: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/inputs/SelectInput.vue').default,IndustryToInterests: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/inputs/IndustryToInterests.vue').default,ButtonSecondary: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/buttons/ButtonSecondary.vue').default,ButtonPrimary: require('/home/forge/portal.gradlinc.co.za/releases/20260824084656/components/buttons/ButtonPrimary.vue').default})
